import { APIInstance } from "./api.config";

const api = new APIInstance({ path: "/v2" }).api;

export const SubContractorService = {
  getSubContractors: (companyId, limit, page_number) => {
    let url = `/subcontractors?fields=id,name,mobile,place&type=SubContractor&companyId=${companyId}`;
    url += limit && page_number ? `&pageSize=${limit}&pageNumber=${page_number}` : "";
    return api.get(url);
  },

  createSubContractor: (data) => {
    return api.post("/subcontractors", data);
  },

  updateSubContractor: (id, data) => {
    return api.put(`/subcontractors/${id}`, data);
  },

  addContract: (payload) => {
    return api.post("/contracts", payload);
  },

  getContract: (contractId) => {
    return api.get(`/contracts/${contractId}`);
  },

  updateContract: (contractId, payload) => {
    return api.put(`/contracts/${contractId}`, payload);
  },

  subcontractorDetails: (id) => {
    return api.get(`/subcontractors/${id}`);
  },

  deleteSubcontractor: (id) => {
    return api.delete(`/subcontractors/${id}`);
  },

  allContracts: (pageSize, pageNumber, subcontractorId, searchText) => {
    let url = `/subcontractors/${subcontractorId}/contracts?pageSize=${pageSize}&pageNumber=${pageNumber}`;
    url += searchText ? `&searchText=${searchText}` : "";
    return api.get(url);
  },

  deleteContract: (contractId, subcontractorId, amount) => {
    return api.delete(`/contracts/${contractId}?subcontractorId=${subcontractorId}&amount=${amount}`);
  },

  getTransactions: (subcontractorId, pageSize, pageNumber, searchText) => {
    let url = `/subcontractors/${subcontractorId}/transactions?pageSize=${pageSize}&pageNumber=${pageNumber}`;
    url += searchText ? `&searchText=${searchText}` : "";
    return api.get(url);
  },

  deleteTransaction: (transactionId) => {
    return api.delete(`/subcontractors/transaction/${transactionId}`);
  },
};
